import { useTranslation } from 'react-i18next';
import type { UsersAndTeams } from '@momentum/types';
import {
  PersonAvatar,
  TeamIcon,
} from '@/shared/components/people-team-list/PeopleTeamAvatars';
import type { EmployeeInfo } from '../../../constants';
import { getInitials } from './AvatarStack';

export function ReadOnlyList({
  value,
  employeeMap,
  teamMap,
}: {
  value: UsersAndTeams;
  employeeMap: Map<string, EmployeeInfo>;
  teamMap: Map<string, string>;
}) {
  const { t } = useTranslation('knowledge');

  return (
    <div className="max-h-[220px] overflow-y-auto py-1">
      {(value.teams?.length ?? 0) > 0 && (
        <>
          <div className="px-2.5 pb-1 pt-2 text-[11px] font-semibold uppercase tracking-[0.04em] text-muted-foreground">
            {t('pickerTeamsGroup')}
          </div>
          {value.teams?.map((teamId) => (
            <div
              key={teamId}
              className="flex items-center gap-2 px-2.5 py-1.5 text-[13px] text-foreground"
            >
              <TeamIcon />
              <span>{teamMap.get(teamId) ?? t('detailUnknownTeam')}</span>
            </div>
          ))}
        </>
      )}

      {(value.users?.length ?? 0) > 0 && (
        <>
          <div className="px-2.5 pb-1 pt-2 text-[11px] font-semibold uppercase tracking-[0.04em] text-muted-foreground">
            {t('pickerPeopleGroup')}
          </div>
          {value.users?.map((userId) => {
            const emp = employeeMap.get(userId);
            return (
              <div
                key={userId}
                className="flex items-center gap-2 px-2.5 py-1.5 text-[13px] text-foreground"
              >
                <PersonAvatar
                  initials={emp ? getInitials(emp.fullName) : '??'}
                  imageUrl={emp?.imageUrl}
                />
                <span>{emp?.fullName ?? userId}</span>
              </div>
            );
          })}
        </>
      )}
    </div>
  );
}
